<template>
    <div class="page-container">
        <!-- 搜索区域 -->
        <el-row style="margin-top: 2vh; padding: 0 20px;">
            <el-col :span="24">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="食材名称">
                        <el-input v-model="formInline.dishName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                        <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                        <!-- 新增按钮加boom动画触发 -->
                        <el-button type="primary" @click="openAddModal" class="add-btn">
                            <i class="el-icon-plus"></i> 新增食材
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 食材列表展示 -->
            <el-col :span="24" class="card-container-wrapper">
                <div class="card-container">
                    <el-row :gutter="20">
                        <!-- 食材卡片 -->
                        <el-col :span="6" v-for="(item, index) in filteredList" :key="item.id || index"
                            class="card-item">
                            <el-card shadow="hover" class="ingredient-card">
                                <div class="card-header">
                                    <img :src="item.coverImg" :alt="item.name" class="ingredient-img">
                                </div>
                                <div class="card-body">
                                    <h3 class="ingredient-name">{{ item.dishName }}</h3>
                                    <p><span class="label">分类：</span>{{ item.category }}</p>
                                    <p><span class="label">功能间：</span>{{ item.room }} </p>
                                </div>
                                <div class="card-actions">
                                    <el-button size="mini" type="primary" icon="el-icon-edit"
                                        @click="openEditModal(item)">修改</el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete"
                                        @click="handleDelete(item)">删除</el-button>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!-- 无数据提示 -->
                    <div v-if="filteredList.length === 0" class="no-data">
                        <el-empty description="暂无食材数据"></el-empty>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="pagination-container">
                    <el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[4, 8, 16, 32]" :page-size="pageSize" background
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 新增/编辑弹窗（添加用料清单） -->
        <el-dialog :title="isEdit ? '编辑食材' : '新增食材'" :visible.sync="dialogVisible" width="800px"
            :close-on-click-modal="false" :z-index="2000" append-to-body
            :class="{ 'boom-animation': dialogVisible && !isEdit }">
            <el-form ref="form" :model="formData" :rules="formRules" label-width="120px">
                <!-- 基础信息区域 -->
                <el-form-item label="食材名称" prop="dishName">
                    <el-input v-model="formData.dishName" placeholder="请输入食材名称"></el-input>
                </el-form-item>
                <el-form-item label="菜品编号" prop="dishCode">
                    <el-input v-model="formData.dishCode" placeholder="请输入菜品编号"></el-input>
                </el-form-item>
                <el-form-item label="功能间" prop="room">
                    <el-select v-model="formData.room" placeholder="选择功能间">
                        <el-option v-for="room in roomList" :key="room.roomName" :label="room.roomName"
                            :value="room.roomName"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="类型" prop="category">
                    <el-input v-model="formData.category" placeholder="请输入菜品类型"></el-input>
                </el-form-item>

                <el-form-item label="价格" prop="price">
                    <el-input v-model.number="formData.price" placeholder="请输入价格（元）"
                        prefix-icon="el-icon-money"></el-input>
                </el-form-item>

                <el-form-item label="菜品介绍" prop="introduction">
                    <el-input v-model="formData.introduction" type="textarea" rows="4"
                        placeholder="请输入菜品详细介绍，包括口味特点、历史背景等"></el-input>
                </el-form-item>
                <el-form-item label="菜品图片" prop="imgFile">
                    <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleImgChange"
                        :before-upload="beforeImageUpload" :file-list="fileList" accept="image/jpg,image/png"
                        :limit="1">
                        <el-button size="small" type="primary">选择图片</el-button>
                        <div slot="tip" class="el-upload__tip">支持JPG/PNG格式，大小不超过200k</div>
                    </el-upload>
                </el-form-item>

                <!-- 新增：菜品用料明细区域 -->
                <el-form-item label="菜品用料明细">
                    <div class="material-detail-wrapper">
                        <el-table :data="formData.dishes" border style="width: 100%;" :empty-text="emptyMaterialText">
                            <!-- 核心修改：食材名称输入框改为下拉框，适配templateList接口数据 -->
                            <el-table-column prop="dishName" label="食材名称" min-width="80">
                                <template #default="scope">
                                    <el-select v-model="scope.row.dishName" placeholder="选择食材名称" clearable
                                        style="width: 100%;" filterable>
                                        <!-- 遍历getTemplateList接口返回的templateList，渲染下拉选项 -->
                                        <el-option v-for="(template, idx) in templateList" :key="idx"
                                            :label="template.pname" :value="template.pname"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amount" label="用量" min-width="80">
                                <template #default="scope">
                                    <el-input v-model.number="scope.row.amount" placeholder="请输入用量"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unit" label="单位" min-width="80">
                                <template #default="scope">
                                    <el-input v-model="scope.row.unit" placeholder="请输入单位"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" min-width="150">
                                <template #default="scope">
                                    <el-input v-model="scope.row.remark" placeholder="请输入备注"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="80">
                                <template #default="scope">
                                    <el-button size="mini" type="danger"
                                        @click="removeMaterial(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" icon="el-icon-plus" size="mini" class="add-material-btn"
                            @click="addMaterial">添加用料</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>

        <!-- 详情弹窗（展示用料清单） -->
        <el-dialog title="食材详情" :visible.sync="detailVisible" width="700px" :z-index="2000" append-to-body>
            <div class="detail-info">
                <div class="detail-img-container">
                    <img :src="getImgUrl(currentItem.image)" :alt="currentItem.name" class="detail-img">
                </div>
                <el-descriptions column="1" border>
                    <el-descriptions-item label="食材名称">{{ currentItem.dishName || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="菜品编号">{{ currentItem.dishCode || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="功能间">{{ currentItem.room || currentItem.functionRoom || '无'
                        }}</el-descriptions-item>

                    <el-descriptions-item label="价格">{{ currentItem.price || 0 }} 元</el-descriptions-item>
                    <el-descriptions-item label="菜品介绍">{{ currentItem.introduction || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="入库时间">{{ currentItem.createTime }}</el-descriptions-item>
                </el-descriptions>

                <!-- 详情页展示用料清单 -->
                <div class="detail-material" v-if="currentItem.dishes && currentItem.dishes.length > 0">
                    <h4 style="margin: 15px 0;">菜品用料明细</h4>
                    <el-table :data="parseDishesData(currentItem.dishes)" border style="width: 100%;">
                        <el-table-column prop="dishName" label="食材名称"></el-table-column>
                        <el-table-column prop="amount" label="用量"></el-table-column>
                        <el-table-column prop="unit" label="单位"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getRoomList } from "@/api/function";
import { getDishList, add, del, edit } from "@/api/dish";
import { getAllProducts } from "@/api/ingredients";
export default {
    data() {
        return {
            total: 0, // 由接口返回总数
            // 搜索表单
            formInline: {
                dishName: '',
                category: ''
            },
            // 功能间列表
            roomList: [],
            // 食材列表（接口返回数据）
            ingredientList: [],
            // 模板列表（getTemplateList接口返回，用于食材名称下拉框）
            templateList: [],
            // 默认图片
            defaultImg: '',
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            // 弹窗状态
            dialogVisible: false,
            detailVisible: false,
            // 编辑状态
            isEdit: false,
            // 当前操作项
            currentItem: {},
            // 表单数据
            formData: {
                dishName: '',
                dishCode: '',
                room: '', // 功能间
                dishType: '半成品',
                name: '',
                category: '',
                spec: '',
                unit: '',
                price: 0,
                calorie: 0,
                introduction: '',
                remark: '',
                image: '', // 纯base64图片（无前缀）
                dishes: [] // 菜品用料清单
            },
            // 图片上传
            fileList: [],
            // 用料清单空提示
            emptyMaterialText: '暂无用料记录，请点击新增',
            // 表单验证规则
            formRules: {
                dishName: [
                    { required: true, message: '请输入食材名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在1-30个字符之间', trigger: 'blur' }
                ],
                dishCode: [
                    { required: true, message: '请输入菜品编号', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9]+$/, message: '只能包含字母和数字', trigger: 'blur' }
                ],
                room: [
                    { required: true, message: '请选择功能间', trigger: 'change' }
                ],
                category: [
                    { required: true, message: '请输入菜品类型', trigger: 'blur' }
                ],

            }
        }
    },
    computed: {
        // 筛选后的列表（结合搜索条件）
        filteredList() {
            let list = [...this.ingredientList];
            // 名称筛选（兼容dishName和name字段）
            if (this.formInline.dishName) {
                const searchVal = this.formInline.dishName.toLowerCase();
                list = list.filter(item =>
                (item.dishName?.toLowerCase().includes(searchVal) ||
                    item.name?.toLowerCase().includes(searchVal))
                );
            }
            // 分类筛选
            if (this.formInline.category) {
                list = list.filter(item => item.category === this.formInline.category);
            }
            return list;
        }
    },
    created() {
        this.loadRoomList(); // 加载功能间
        this.loadDishList(); // 加载菜品列表
        this.getTemplateList(); // 页面创建时获取模板列表，为下拉框提供数据
    },
    methods: {
        // 获取模版列表（接口逻辑不变，用于食材名称下拉框数据源）
        getTemplateList() {
            getAllProducts({
                userId: localStorage.getItem('userId'),
            }).then(response => {
                this.templateList = response.data || []; // 赋值给templateList，供下拉框遍历
                console.log(response.data);
            }).catch(error => {
                console.error('获取模版列表失败:', error);
                this.$message.error('获取数据失败，请重试');
            });
        },
        // 新增：上传前校验文件大小和类型
        beforeImageUpload(file) {
            // 1. 校验文件类型（只允许JPG/PNG）
            const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
            // 2. 校验文件大小（200KB）
            const isLt200K = file.size / 1024 < 200;

            if (!isImage) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
                return false; // 阻止文件上传
            }

            if (!isLt200K) {
                this.$message.error('上传图片大小不能超过 200KB!');
                return false; // 阻止文件上传
            }

            return true; // 校验通过
        },

        /**
         * 处理图片URL（补全base64前缀）
         * @param {String} imgStr 纯base64字符串（无前缀）
         * @returns 完整的图片URL
         */
        getImgUrl(imgStr) {
            if (!imgStr) return this.defaultImg;
            // 如果是纯base64（无前缀），补全webp前缀
            if (!imgStr.startsWith('data:image/')) {
                return `data:image/webp;base64,${imgStr}`;
            }
            return imgStr;
        },

        /**
         * 移除base64前缀
         * @param {String} base64Str 带前缀的base64字符串
         * @returns 纯base64字符串
         */
        removeBase64Prefix(base64Str) {
            if (!base64Str) return '';
            return base64Str.replace(/^data:image\/\w+;base64,/, '');
        },

        /**
         * 解析用料数据（兼容JSON字符串/数组）
         * @param {String|Array} dishesData 接口返回的用料数据
         * @returns 标准化的用料数组
         */
        parseDishesData(dishesData) {
            if (!dishesData) return [];
            // 情况1：接口返回的是JSON字符串
            if (typeof dishesData === 'string') {
                try {
                    return JSON.parse(dishesData);
                } catch (e) {
                    console.error('解析用料明细失败：', e);
                    return [];
                }
            }
            // 情况2：接口返回的是数组（直接使用）
            if (Array.isArray(dishesData)) {
                return [...dishesData];
            }
            // 其他情况：返回空数组
            return [];
        },

        // 加载功能间列表
        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
                console.error('功能间加载失败：', error);
            }
        },

        // 加载菜品列表（查询接口）
        async loadDishList() {
            try {
                // 构造查询参数
                const params = {
                    userId: localStorage.getItem('userId'),
                    type: '半成品',

                };
                const res = await getDishList(params);
                // 适配接口返回格式
                this.ingredientList = res.data?.records || res.data || [];
                this.total = res.data?.total || res.data.length || 0;
            } catch (error) {
                this.$message.error('加载菜品列表失败');
                console.error('菜品列表加载失败：', error);
            }
        },

        // 搜索
        onSubmit() {
            this.currentPage = 1;
            this.loadDishList();
        },

        // 重置搜索
        resetSearch() {
            this.formInline = {
                dishName: '',
                category: ''
            };
            this.currentPage = 1;
            this.loadDishList();
        },

        // 打开新增弹窗
        openAddModal() {
            this.isEdit = false;
            this.dialogVisible = true;
            // 重置表单
            this.formData = {
                dishName: '',
                dishCode: '',
                room: '',
                dishType: '半成品',
                name: '',
                category: '',
                spec: '',
                unit: '',
                stock: 0,
                price: 0,
                calorie: 0,
                introduction: '',
                remark: '',
                image: '',
                dishes: []
            };
            this.fileList = [];
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },

        // 打开编辑弹窗（核心修复：用料明细回显）
        openEditModal(item) {
            this.isEdit = true;
            this.currentItem = { ...item };
            // 回显表单数据
            this.formData = {
                ...item,
                room: item.room || item.functionRoom, // 兼容字段
                image: item.image || '', // 纯base64（无前缀）
                // 解析用料明细（兼容字符串/数组）
                dishes: this.parseDishesData(item.dishes || item.dishesString)
            };

            // 处理图片回显：补全前缀
            if (item.image) {
                this.fileList = [{ url: this.getImgUrl(item.image) }];
            } else {
                this.fileList = [];
            }

            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },

        // 打开详情
        openDetail(item) {
            this.currentItem = { ...item };
            this.detailVisible = true;
        },

        // 图片选择事件（添加二次校验）
        handleImgChange(file, fileList) {
            // 二次校验，防止绕过 before-upload 的情况
            if (file.raw && file.raw.size / 1024 >= 200) {
                this.$message.error('上传图片大小不能超过 200KB!');
                // 移除不符合要求的文件
                this.fileList = fileList.filter(item => item.uid !== file.uid);
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                // 移除前缀，只保留纯base64
                this.formData.image = this.removeBase64Prefix(e.target.result);
                // 回显图片（补全前缀）
                this.fileList = [{ url: e.target.result }];
            };
            reader.readAsDataURL(file.raw);
        },

        // 新增用料
        addMaterial() {
            this.formData.dishes.push({
                dishName: '',
                amount: 0,
                unit: '',
                remark: ''
            });
        },

        // 删除用料
        removeMaterial(row) {
            const index = this.formData.dishes.findIndex(item => item === row);
            if (index !== -1) {
                this.formData.dishes.splice(index, 1);
            }
        },

        // 提交表单（新增/编辑）
        async submitForm() {
            try {
                // 表单验证
                const valid = await new Promise((resolve) => {
                    this.$refs.form.validate((valid) => {
                        resolve(valid);
                    });
                });
                if (!valid) return;

                // 构造提交数据
                const submitData = {
                    ...this.formData,
                    id: this.isEdit ? this.currentItem.id : undefined, // 编辑时传id
                    userId: localStorage.getItem('userId'),
                    dishesString: JSON.stringify(this.formData.dishes), // 数组转JSON字符串
                    // image字段已处理为纯base64（无前缀）
                };

                if (this.isEdit) {
                    // 编辑接口
                    await edit(submitData);
                    this.$message.success('编辑成功！');
                } else {
                    // 新增接口
                    await add(submitData);
                    this.$message.success('新增成功！💥');
                }

                // 关闭弹窗+刷新列表
                this.dialogVisible = false;
                this.loadDishList();
                this.fileList = [];
            } catch (error) {
                this.$message.error(this.isEdit ? '编辑失败' : '新增失败');
                console.error('提交失败：', error);
            }
        },

        // 删除菜品
        async handleDelete(item) {
            try {
                await this.$confirm(`确定要删除【${item.dishName || item.name}】吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                // 调用删除接口
                await del({ id: item.id, userId: localStorage.getItem('userId') });
                this.$message.success('删除成功');
                // 刷新列表
                this.loadDishList();
            } catch (error) {
                if (error !== 'cancel') { // 排除取消操作的错误
                    this.$message.error('删除失败');
                    console.error('删除失败：', error);
                } else {
                    this.$message.info('已取消删除');
                }
            }
        },

        // 分页大小变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.loadDishList();
        },

        // 页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadDishList();
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {

    background-color: #f5f7fa;
    min-height: 100vh;
    box-sizing: border-box;
}

/* 新增按钮hover动画 */
.add-btn {
    transition: transform 0.3s;

    &:hover {
        transform: scale(1.05);
    }
}

/* 新增弹窗boom动画 */
.boom-animation {
    animation: boom 0.5s ease-out;
}

@keyframes boom {
    0% {
        transform: scale(0.8);
        opacity: 0;
    }

    50% {
        transform: scale(1.1);
        opacity: 1;
    }

    100% {
        transform: scale(1);
    }
}

.card-container-wrapper {
    margin-top: 20px;
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 10px 0;
}

.card-item {
    flex: 1;
    min-width: 250px;
}

.ingredient-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all 0.3s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }
}

.card-header {
    position: relative;
    height: 160px;
    overflow: hidden;

    .ingredient-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s;

        &:hover {
            transform: scale(1.05);
        }
    }
}

.card-body {
    padding: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;

    .ingredient-name {
        margin: 0 0 10px 0;
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    p {
        margin: 5px 0;
        font-size: 13px;
        color: #666;

        .label {
            color: #999;
        }
    }
}

.card-actions {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    border-top: 1px solid #f0f0f0;
}

.no-data {
    text-align: center;
    padding: 50px 0;
}

.pagination-container {
    padding: 20px 0;
    margin-top: auto;
    background-color: #fff;
    z-index: 2;
    position: sticky;
    position: fixed;
    width: 96%;
    bottom: 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.detail-info {
    padding: 10px 0;

    .detail-img-container {
        text-align: center;
        margin-bottom: 20px;

        .detail-img {
            width: 200px;
            height: 150px;
            object-fit: cover;
            border-radius: 4px;
        }
    }

    .detail-material {
        margin-top: 20px;
        border-top: 1px dashed #eee;
        padding-top: 15px;
    }
}

/* 用料清单样式 */
.material-detail-wrapper {
    margin-top: 10px;

    .add-material-btn {
        margin-top: 10px;
    }
}

::v-deep .el-descriptions__cell {
    padding: 12px 10px;
}

::v-deep .el-descriptions__label {
    font-weight: 500;
}

::v-deep .el-upload__tip {
    font-size: 12px;
    color: #999;
}
</style>